import { resources } from "@constants/hardcoded-strings";
import { RelyingPartyDetailsCustomHostnamesValidationErrors, RelyingPartyDetailsGeneralInfoValidationErrors, RelyingPartyDetailsValidationErrors } from "@idw-types/common/validation/relying-party/relying-party-details/relying-party-details-validation-errors";
import { FormattedRelyingPartyConfig } from "@idw-types/data/relying-party-config";
import { getErrorAlert, getTabTitle } from "@utils/tab-util";

export const getRelyingPartyDetailsValidationErrors = (relyingParty: FormattedRelyingPartyConfig): RelyingPartyDetailsValidationErrors => {
    const generalInfoErrors = getRelyingPartyDetailsGeneralInfoValidationErrors(relyingParty);
    const customHostnamesErrors = getRelyingPartyDetailsCustomHostnamesInfoValidationErrors(relyingParty);

    const count = generalInfoErrors.count + customHostnamesErrors.count;

    return {
        count,
        generalInfo: generalInfoErrors,
        customHostnames: customHostnamesErrors
    };
};

const getRelyingPartyDetailsGeneralInfoValidationErrors = (relyingParty: FormattedRelyingPartyConfig): RelyingPartyDetailsGeneralInfoValidationErrors => {
    let count = 0;

    let relyingPartyNameError = null;

    if(relyingParty.name === ""){
        relyingPartyNameError = getErrorAlert(resources.common.requiredField);
        count++;
    }

    return {
        count,
        relyingPartyNameError,
        tabTitle: getTabTitle(resources.pages.relyingPartyDetails.tabs.details.tabName, count)
    };
};

const getRelyingPartyDetailsCustomHostnamesInfoValidationErrors = (relyingParty: FormattedRelyingPartyConfig): RelyingPartyDetailsCustomHostnamesValidationErrors => {
    let count = 0;

    let customAXNHostnameError = null;
    let customDCUIHostnameError = null;
    let whiteLabelKBAHostnameError = null;
    let whiteLabelKBA2HostnameError = null;
    let whiteLabelAXNUIHostnameError = null;
    let whiteLabelDCUIHostnameError = null;
    let whiteLabelAXNUI3HostnameError = null;

    if ((relyingParty.customAXNHostName || "").includes(" ")) {
        customAXNHostnameError = getErrorAlert(resources.common.errors.invalidURL);
        count++;
    }

    if ((relyingParty.customDCUIHostName || "").includes(" ")) {
        customDCUIHostnameError = getErrorAlert(resources.common.errors.invalidURL);
        count++;
    }

    if ((relyingParty.whiteLabelKBAHostName || "").includes(" ")) {
        whiteLabelKBAHostnameError = getErrorAlert(resources.common.errors.invalidURL);
        count++;
    }

    if ((relyingParty.whiteLabelKBA2HostName || "").includes(" ")) {
        whiteLabelKBA2HostnameError = getErrorAlert(resources.common.errors.invalidURL);
        count++;
    }

    if ((relyingParty.whiteLabelAXNUIHostName || "").includes(" ")) {
        whiteLabelAXNUIHostnameError = getErrorAlert(resources.common.errors.invalidURL);
        count++;
    }

    if ((relyingParty.whiteLabelDCUIHostName || "").includes(" ")) {
        whiteLabelDCUIHostnameError = getErrorAlert(resources.common.errors.invalidURL);
        count++;
    }

    if ((relyingParty.whiteLabelAXNUI3HostName || "").includes(" ")) {
        whiteLabelAXNUI3HostnameError = getErrorAlert(resources.common.errors.invalidURL);
        count++;
    }

    return {
        count,
        customAXNHostnameError,
        customDCUIHostnameError,
        whiteLabelKBAHostnameError,
        whiteLabelKBA2HostnameError,
        whiteLabelAXNUIHostnameError,
        whiteLabelDCUIHostnameError,
        whiteLabelAXNUI3HostnameError,
        tabTitle: getTabTitle(resources.pages.relyingPartyDetails.tabs.customHostnames.tabName, count) 
    }
};